import type { EmptyStateProps } from '@prerender/design-system/EmptyState';

export const EMPTY_STATE_VIEWED_EVENT = 'Empty State Viewed';
export const EMPTY_STATE_ACTION_CLICKED_EVENT = 'Empty State Action Clicked';

export type EmptyStateScreen = 'dashboard' | 'cdn_analytics' | 'ai_insights_discoverability';

export type EmptyStateKind =
  | 'not_integrated'
  | 'no_data_yet'
  | 'filter_empty'
  | 'nothing_wrong'
  | 'failed_to_load'
  | 'not_configured';

const KIND_BY_STATE: Record<EmptyStateProps['state'], EmptyStateKind> = {
  'not-integrated': 'not_integrated',
  'no-data': 'no_data_yet',
  filtered: 'filter_empty',
  'nothing-wrong': 'nothing_wrong',
  error: 'failed_to_load',
  'not-configured': 'not_configured',
};

export function emptyStateKindOf(state: EmptyStateProps['state']): EmptyStateKind {
  return KIND_BY_STATE[state];
}

export type FilterEmptyVariant = 'narrowed' | 'default_window' | 'no_crawlers_selected';
export type NoDataVariant = 'stalled';
export type EmptyStateVariant = FilterEmptyVariant | NoDataVariant;

export type EmptyStatePlacement = 'page' | 'widget';

export type EmptyStateViewedPayload = {
  screen: EmptyStateScreen;
  state: EmptyStateKind;
  placement: EmptyStatePlacement;
  variant?: EmptyStateVariant;
};

export type EmptyStateActionClickedPayload = EmptyStateViewedPayload & {
  action_id: string;
  destination: string;
};
